/**
 * The canvas's top layer (Shell's `overlays`), for a part that must open over the whole canvas while its state stays
 * in a module: the chat's large keyboard on the bottom edge. Null until the layer is mounted, and outside a Shell.
 */
import { createContext, useContext } from 'react';

export const OverlayRootContext = createContext<HTMLElement | null>(null);

export function useOverlayRoot(): HTMLElement | null {
  return useContext(OverlayRootContext);
}
